
import {rollbar}  from './rollbar/rollbar'

export default {
	install: (app: any): void => {
		app.config.errorHandler = (error: any, vm, info ): void => {
			if(rollbar === null){
				return;
			}
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			rollbar?.error(error as Error, {info});
			throw error;
		};
		// eslint-disable-next-line @typescript-eslint/no-unsafe-call
		app.provide("rollbar", rollbar);
	},
};
